import React from "react";
import "../styles/Blog.css";
import { getBlogBySlug } from "../data/blogPosts";

function formatDate(dateStr) {
  return new Date(dateStr).toLocaleDateString("en-IN", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

export default function BlogPost({ slug, navigate }) {
  const post = getBlogBySlug(slug);

  if (!post) {
    return (
      <section className="blog-section blog-post-page">
        <div className="blog-post-not-found">
          <h1>Article not found</h1>
          <p>The blog post you are looking for does not exist.</p>
          <button type="button" className="read-btn" onClick={() => navigate("/blog")}>
            Back to Blog
          </button>
        </div>
      </section>
    );
  }

  return (
    <article className="blog-section blog-post-page" itemScope itemType="https://schema.org/BlogPosting">
      <nav className="blog-breadcrumb" aria-label="Breadcrumb">
        <button type="button" onClick={() => navigate("/")}>Home</button>
        <span aria-hidden="true"> / </span>
        <button type="button" onClick={() => navigate("/blog")}>Blog</button>
        <span aria-hidden="true"> / </span>
        <span className="blog-breadcrumb-current">{post.tag}</span>
      </nav>

      <header className="blog-post-header">
        <span className="blog-tag">{post.tag}</span>
        <h1 itemProp="headline">{post.title}</h1>
        <p className="blog-post-meta">
          <time dateTime={post.date} itemProp="datePublished">
            {formatDate(post.date)}
          </time>
          {" · "}
          <span itemProp="author">{post.author}</span>
          {post.readTime ? ` · ${post.readTime}` : ""}
        </p>
      </header>

      <div className="blog-post-body" itemProp="articleBody">
        {post.sections.map((section) => (
          <section key={section.heading}>
            <h2>{section.heading}</h2>
            {section.paragraphs.map((paragraph, i) => (
              <p key={i}>{paragraph}</p>
            ))}
          </section>
        ))}
      </div>

      <div className="blog-post-cta">
        <p>Ready to start learning? Explore our courses or get in touch.</p>
        <div className="blog-post-cta-actions">
          <button type="button" className="read-btn" onClick={() => navigate("/courses")}>
            View Courses
          </button>
          <button type="button" className="blog-cta-secondary" onClick={() => navigate("/contact")}>
            Contact Us
          </button>
        </div>
      </div>
    </article>
  );
}
